// @flow

import { type LookAndFeel } from '@tectonics/look-and-feel';

const volcanes: LookAndFeel = {
  code: 'volcanes',
  displayName: 'Volcanes',
  getRootComponent: () => import('./volcanes'),
  getLoadingPage: () => import('@tectonics/components/loading-page'),
  prsSupport: {
    integrations: {
      br: ['creditcard', 'debitcard', 'pix', 'boleto', 'banktransfer', 'tef', 'google', 'ewallet', 'vouchercard', 'multibeneficios', 'nupay', 'itau-pay', 'mpcredito', 'externalpayprovider', 'cryptocurrency'],
      mx: ['creditcard', 'debitcard', 'oxxo', 'paynet', 'spei', 'oxxopay', 'ewallet', 'google', 'externalpayprovider', 'cryptocurrency'],
      ar: ['creditcard', 'debitcard', 'ewallet', 'qr', 'cash', 'banktransfer', 'cryptocurrency'],
      co: ['creditcard', 'debitcard', 'externalpayprovider', 'eft', 'cash', 'ewallet', 'transfiya', 'breb'],
      pe: ['creditcard', 'debitcard', 'pagoefectivo', 'safetypay-online', 'safetypay-cash', 'banktransfer', 'ewallet', 'cryptocurrency'],
      cl: ['creditcard', 'debitcard', 'multicaja', 'webpay', 'sencillito', 'servipag', 'ewallet', 'google', 'banktransfer', 'cryptocurrency'],
      bo: ['cash'],
      ec: ['safetypay-cash', 'safetypay-online', 'creditcard', 'debitcard'],
      uy: ['creditcard', 'debitcard', 'ewallet', 'cryptocurrency'],
      cr: ['creditcard', 'debitcard', 'cash','cryptocurrency'],
      py: ['creditcard', 'debitcard', 'cryptocurrency'],
      pa: ['creditcard', 'debitcard', 'cash'],
      gt: ['creditcard', 'debitcard', 'cash', 'cryptocurrency'],
      sv: ['creditcard', 'debitcard', 'cash', 'cryptocurrency'],
      do: ['creditcard', 'debitcard', 'cryptocurrency'],
      za: ['ewallet', 'creditcard', 'externalpayprovider', 'debitcard'],
      ke: ['ewallet', 'creditcard', 'debitcard'],
      ng: ['ewallet', 'nibbs', 'banktransfer', 'creditcard', 'debitcard', 'externalpayprovider'],
      ph: ['ewallet'],
      in: ['ewallet', 'creditcard', 'debitcard'],
      tz: ['ewallet'],
      ug: ['ewallet'],
      zm: ['ewallet'],
      ci: ['ewallet'],
      sn: ['ewallet'],
      eg: ['creditcard', 'debitcard', 'externalpayprovider', 'meeza'],
      gh: ['ewallet'],
      id: ['ewallet', 'banktransfer'],
      jm: ['creditcard', 'debitcard'],
      th: ['ewallet'],
      tr: ['creditcard', 'banktransfer'],
      my: ['ewallet'],
    },
    features: [
      { name: 'name' },
      { name: 'email' },
      { name: 'phone_number' },
      { name: 'field_customer_name' },
      {
        name: 'field_brazilian_document',
        traits: ['type_cpf', 'type_cnpj'],
      },
      { name: 'field_customer_email' },
      { name: 'field_brazilian_zipcode' },
      { name: 'field_brazilian_phone_number' },
      { name: 'field_brazilian_state' },
      { name: 'field_brazilian_city' },
      { name: 'field_brazilian_address' },
      { name: 'field_brazilian_street_number' },
      { name: 'field_brazilian_street_complement' },
      { name: 'field_mexican_zipcode' },
      { name: 'field_mexican_phone_number' },
      { name: 'field_mexican_state' },
      { name: 'field_mexican_city' },
      { name: 'field_mexican_address' },
      { name: 'field_mexican_street_number' },
      { name: 'field_mexican_street_complement' },
      { name: 'field_argentine_document' },
      { name: 'field_argentine_document_type' },
      { name: 'field_argentine_zipcode' },
      { name: 'field_argentine_phone_number' },
      { name: 'field_argentine_state' },
      { name: 'field_argentine_city' },
      { name: 'field_argentine_address' },
      { name: 'field_argentine_street_number' },
      { name: 'field_argentine_street_complement' },
      { name: 'field_argentine_cash_bank_list' },
      { name: 'field_argentine_cbu' },
      { name: 'field_argentine_company_name' },
      { name: 'field_argentine_accept_terms_withhold_taxes' },
      { name: 'instruction_text_certificate_withhold_taxes' },
      {
        name: 'display_argentine_accepts_cash_methods',
        traits: ['rapipago', 'pagofacil'],
      },
      { name: 'display_argentine_receipt_tax_iva' },
      { name: 'display_argentine_receipt_tax_ip' },
      { name: 'display_argentine_receipt_tax_ig_ibp' },
      { name: 'display_argentine_receipt_tax_iibb' },
      { name: 'display_paraguayan_receipt_tax_iva' },
      { name: 'display_costa_rican_receipt_tax_iva' },
      { name: 'display_el_salvador_receipt_tax_itbms' },
      { name: 'display_india_receipt_tax_gst' },
      { name: 'field_card_holder_name' },
      { name: 'field_card_number' },
      { name: 'field_card_expiry_date' },
      { name: 'field_card_security_code' },
      { name: 'field_card_instalments' },
      { name: 'field_accept_visa_terms' },
      { name: 'field_tef_select_bank' },
      { name: 'display_merchant_logo' },
      { name: 'display_receipt_original_amount' },
      { name: 'display_receipt_fx_rate' },
      { name: 'display_brazilian_receipt_tax_iof' },
      { name: 'display_receipt_final_amount' },
      { name: 'display_selected_instalment' },
      { name: 'display_boleto_total_value' },
      { name: 'display_boleto_due_date' },
      { name: 'display_boleto_barcode' },
      { name: 'display_boleto_number' },
      { name: 'display_boleto_tips' },
      { name: 'action_boleto_copy_code' },
      { name: 'action_boleto_save_pdf' },
      { name: 'display_boleto_email_warning' },
      { name: 'action_oxxo_save_pdf' },
      { name: 'display_oxxo_success_message' },
      { name: 'display_oxxo_number' },
      { name: 'display_oxxo_instructions' },
      { name: 'display_oxxo_ticket_info' },
      { name: 'display_oxxo_tips' },
      { name: 'display_oxxo_total_amount' },
      { name: 'display_oxxo_duedate' },
      { name: 'display_cash_total_value', traits: [] },
      { name: 'display_cash_due_date', traits: [] },
      { name: 'display_cash_barcode', traits: [] },
      { name: 'display_cash_number', traits: [] },
      { name: 'action_cash_download', traits: [] },
      { name: 'action_cash_save_pdf', traits: [] },
      { name: 'display_cash_email_warning', traits: [] },
      { name: 'display_cash_instructions', traits: [] },
      { name: 'display_cash_tips', traits: [] },
      { name: 'display_paynet_payment_locations', traits: [] },
      { name: 'display_cash_puntos', traits: [] },
      { name: 'display_cash_total_amount' },
      { name: 'display_cash_duedate' },
      { name: 'display_spei_success_message' },
      { name: 'display_spei_total_amount' },
      { name: 'display_spei_due_date' },
      { name: 'display_spei_reference_number' },
      { name: 'display_spei_destination_clabe_number' },
      { name: 'display_spei_destination_bank' },
      { name: 'display_spei_destination_beneficiary' },
      { name: 'action_spei_save_pdf' },
      { name: 'display_spei_instructions' },
      { name: 'display_spei_tips' },
      { name: 'field_colombian_document' },
      { name: 'field_colombian_document_type' },
      { name: 'field_colombian_phone_number' },
      { name: 'field_colombian_transfiya_phone_number' },
      { name: 'field_colombian_zipcode' },
      { name: 'field_colombian_state' },
      { name: 'field_colombian_city' },
      { name: 'field_colombian_address' },
      { name: 'field_colombian_street_number' },
      { name: 'field_colombian_street_complement' },
      { name: 'field_colombian_externalpayprovider_code' },
      { name: 'field_colombian_externalpayprovider_bank_list' },
      { name: 'display_colombian_externalpayprovider_instructions' },
      { name: 'field_chilean_document' },
      { name: 'field_chilean_phone_number' },
      { name: 'field_chilean_zipcode' },
      { name: 'field_chilean_state' },
      { name: 'field_chilean_city' },
      { name: 'field_chilean_address' },
      { name: 'field_chilean_street_number' },
      { name: 'field_chilean_street_complement' },
      { name: 'field_bolivian_phone_number' },
      { name: 'display_webpay_instructions' },
      { name: 'display_webpay_other_methods' },
      { name: 'display_sencillito_instructions' },
      { name: 'display_sencillito_other_methods' },
      { name: 'field_peruvian_document' },
      { name: 'field_peruvian_phone_number' },
      { name: 'field_peruvian_zipcode' },
      { name: 'field_peruvian_state' },
      { name: 'field_peruvian_city' },
      { name: 'field_peruvian_address' },
      { name: 'field_peruvian_street_number' },
      { name: 'field_peruvian_street_complement' },
      { name: 'display_pagoefectivo_instructions' },
      { name: 'display_pagoefectivo_other_methods_tip' },
      { name: 'display_safetypay_cash_instructions' },
      { name: 'display_safetypay_cash_banks' },
      { name: 'display_safetypay_cash_other_methods_tip' },
      {
        name: 'display_card_accepts_brand',
        traits: ['mastercard', 'visa', 'elo', 'amex', 'hipercard', 'carnet', 'magna', 'naranja', 'cabal', 'oca', 'lider', 'creditel', 'walmart', 'diners', 'bancard-check', 'jcb', 'infonet', 'discover', 'unionpay', 'credifielco', 'codensa', 'rupay', 'verve', 'troy'],
      },
      {
        name: 'display_alternative_card_accepts_brand',
        traits: ['mastercard', 'visa', 'elo', 'amex', 'hipercard'],
      },
      {
        name: 'display_debit_card_accepts_brand',
        traits: ['mastercard', 'visa', 'nubank', 'santander', 'bancodobrasil', 'caixa', 'bradesco', 'original', 'inter', 'c6', 'bancoob', 'bancopan', 'sicredi', 'agibank', 'bancobmg', 'brb', 'itau', 'infonet', 'diners', 'meeza', 'verve'],
      },
      { name: 'display_paraguayan_creditcard_banks_info', traits: [] },
      { name: 'display_brazilian_debitcard_banks_info', traits: [] },
      {
        name: 'display_tef_bank_accepts_brand',
        traits: ['bancodobrasil', 'banrisul', 'bradesco', 'caixa', 'itau', 'santander'],
      },
      { name: 'hide_amex_card_number' },
      { name: 'field_colombian_bank_list' },
      { name: 'display_servipag_instructions', traits: [] },
      { name: 'display_servipag_other_methods', traits: [] },
      { name: 'display_pagoefectivo_total_value' },
      { name: 'display_pagoefectivo_due_date' },
      { name: 'display_pagoefectivo_cip_code' },
      { name: 'action_pagoefectivo_save_cip_as_pdf' },
      { name: 'display_safetypay_online_instructions' },
      { name: 'display_safetypay_online_banks' },
      { name: 'display_safetypay_online_ec_other_methods_tip' },
      { name: 'display_pagosnet_total_value' },
      { name: 'display_pagosnet_due_date' },
      { name: 'display_pagosnet_success_message' },
      { name: 'display_pagosnet_number' },
      { name: 'action_pagosnet_save_pdf' },
      { name: 'display_pagosnet_tip' },
      { name: 'display_pagosnet_merchant_info' },
      { name: 'display_argentine_cash_total_value' },
      { name: 'display_argentine_cash_due_date' },
      { name: 'display_argentine_cash_barcode' },
      { name: 'display_argentine_cash_number' },
      { name: 'display_argentine_cash_tips' },
      { name: 'action_argentine_cash_save_pdf' },
      { name: 'display_argentine_cash_merchant_info' },
      { name: 'display_argentine_cash_information' },
      { name: 'field_ecuadorian_phone_number' },
      { name: 'field_ecuadorian_document' },
      { name: 'field_ecuadorian_zipcode' },
      { name: 'field_ecuadorian_state' },
      { name: 'field_ecuadorian_city' },
      { name: 'field_ecuadorian_address' },
      { name: 'field_ecuadorian_street_number' },
      { name: 'field_ecuadorian_street_complement' },
      {
        name: 'display_ewallet_accepts_brand',
        traits: ['mercadopago', 'picpay', 'ame', 'paypal', 'machpay', 'mpesa', 'ussd', 'airtel', 'equitel', 'upi-qrcode', 'upi-collect', 'upi-intent', 'vodacom', 'tigo', 'mtn', 'zamtel', 'paymaya', 'g-cash', 'qrph', 'shopee-pay', 'promptpay', 'mobile-banking', 'truemoney', 'dana', 'qr', 'qris', 'touchngo', 'duitnow-pay', 'direct-debit', 'vodafone'],
      },
      {
        name: 'display_cryptocurrency_accepts_brand',
        traits: ['usdc', 'usdt'],
      },
      { name: 'display_efecty_total_value' },
      { name: 'display_efecty_due_date' },
      { name: 'display_efecty_voucher_code' },
      { name: 'field_uruguayan_document' },
      { name: 'field_uruguayan_zipcode' },
      { name: 'field_uruguayan_phone_number' },
      { name: 'field_uruguayan_state' },
      { name: 'field_uruguayan_city' },
      { name: 'field_uruguayan_address' },
      { name: 'field_uruguayan_street_number' },
      { name: 'field_uruguayan_street_complement' },
      { name: 'field_panamanian_document' },
      { name: 'field_panamanian_zipcode' },
      { name: 'field_panamanian_phone_number' },
      { name: 'field_panamanian_state' },
      { name: 'field_panamanian_city' },
      { name: 'field_panamanian_address' },
      { name: 'field_panamanian_street_number' },
      { name: 'field_panamanian_street_complement' },
      {
        name: 'display_panamanian_accepts_cash_methods',
        traits: ['puntoxpress'],
      },
      { name: 'display_panamanian_usd_disclaimer' },
      { name: 'field_costa_rican_document' },
      { name: 'field_costa_rican_zipcode' },
      { name: 'field_costa_rican_phone_number' },
      { name: 'field_costa_rican_state' },
      { name: 'field_costa_rican_city' },
      { name: 'field_costa_rican_address' },
      { name: 'field_costa_rican_street_number' },
      { name: 'field_costa_rican_street_complement' },
      {
        name: 'display_costa_rican_accepts_cash_methods',
        traits: ['puntoxpress'],
      },

      { name: 'field_south_african_customer_email' },
      { name: 'field_south_african_phone_number' },
      { name: 'field_south_african_zipcode' },
      { name: 'field_south_african_state' },
      { name: 'field_south_african_city' },
      { name: 'field_south_african_address' },
      { name: 'field_south_african_street_number' },
      { name: 'field_south_african_street_complement' },

      { name: 'field_kenyan_phone_number' },
      { name: 'field_kenyan_customer_email' },

      { name: 'field_kenyan_zipcode' },
      { name: 'field_kenyan_state' },
      { name: 'field_kenyan_city' },
      { name: 'field_kenyan_address' },
      { name: 'field_kenyan_street_number' },
      { name: 'field_kenyan_street_complement' },
      { name: 'field_kenyan_accept_terms_for_international_transfer' },

      { name: 'display_nigerian_ewallet_instructions' },
      { name: 'field_nigerian_customer_name' },
      { name: 'field_nigerian_customer_email' },
      { name: 'field_nigerian_phone_number' },

      { name: 'field_nigerian_zipcode' },
      { name: 'field_nigerian_state' },
      { name: 'field_nigerian_city' },
      { name: 'field_nigerian_address' },
      { name: 'field_nigerian_street_number' },
      { name: 'field_nigerian_street_complement' },

      { name: 'field_tanzanian_phone_number' },
      { name: 'field_tanzanian_customer_email' },

      { name: 'field_uganda_phone_number' },
      { name: 'field_uganda_customer_email' },

      { name: 'field_philippines_phone_number' },
      { name: 'field_philippines_customer_email' },

      { name: 'field_indonesian_customer_name' },
      { name: 'field_indonesian_customer_email' },
      { name: 'display_indonesian_ewallet_instructions' },

      { name: 'display_malaysian_ewallet_instructions' },
      { name: 'display_mobile_money_instructions' },
      { name: 'field_malaysia_customer_name' },
      { name: 'field_malaysia_customer_email' },

      { name: 'display_thai_ewallet_instructions' },
      { name: 'field_thai_customer_name' },
      { name: 'field_thai_customer_email' },

      { name: 'field_india_customer_name' },
      { name: 'field_india_phone_number' },
      { name: 'field_india_customer_email' },
      { name: 'field_india_upi_id' },
      { name: 'field_india_upi_app' },

      { name: 'field_india_zipcode' },
      { name: 'field_india_state' },
      { name: 'field_india_city' },
      { name: 'field_india_address' },
      { name: 'field_india_street_number' },
      { name: 'field_india_street_complement' },

      { name: 'field_guatemalan_document' },
      { name: 'field_guatemalan_phone_number' },
      {
        name: 'display_guatemalan_accepts_cash_methods',
        traits: ['puntoxpress'],
      },

      { name: 'field_jamaican_customer_email' },

      { name: 'field_jamaican_zipcode' },
      { name: 'field_jamaican_state' },
      { name: 'field_jamaican_city' },
      { name: 'field_jamaican_address' },
      { name: 'field_jamaican_street_number' },
      { name: 'field_jamaican_street_complement' },
      { name: 'field_jamaican_accept_terms_for_international_transfer' },

      { name: 'field_el_salvador_document' },
      { name: 'field_el_salvador_phone_number' },
      {
        name: 'display_el_salvador_accepts_cash_methods',
        traits: ['puntoxpress'],
      },
      {
        name: 'display_virtual_account_bank_list',
        traits: ['cimb', 'bsi', 'bca', 'bnc', 'bni', 'mandiri', 'bri', 'btn', 'permata', 'danamon', 'bss'],
      },

      {
        name: 'display_externalpayprovider_accepts_brand',
        traits: ['bancolombia-button', 'achpse'],
      },

      { name: 'field_egypt_phone_number' },
      { name: 'field_egypt_customer_email' },

      { name: 'field_egypt_zipcode' },
      { name: 'field_egypt_state' },
      { name: 'field_egypt_city' },
      { name: 'field_egypt_address' },
      { name: 'field_egypt_street_number' },
      { name: 'field_egypt_street_complement' },
      { name: 'field_egypt_accept_terms_for_international_transfer' },

      { name: 'field_ghana_phone_number' },
      { name: 'field_ghana_customer_email' },

      { name: 'field_generic_phone_number' },
      { name: 'field_generic_document' },

      { name: 'field_turkish_phone_number' },
      { name: 'field_turkish_customer_email' },

      { name: 'display_turkish_banktransfer_instructions' },
    ],
  },
};

export default volcanes;
